module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Ke-Lb.17894c56.png";